import { useState, useCallback, useEffect } from "react";

import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  message,
  Form,
  Space,
  Modal,
} from "antd";

import { VerticalAlignTopOutlined } from "@ant-design/icons";

import BgProfile from "../assets/cms/profile-background-picture.jpg";
import { Checkbox, Input, Select } from "antd";
import { useHistory, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../components/common/Spinner/Spinner";
import CustomSwitch from "../components/common/Switch/CustomSwitch";
import jwtDecode from "jwt-decode";

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    sm: {
      span: 16,
    },
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0,
    },
    sm: {
      span: 16,
      offset: 8,
    },
  },
};

const companies = [
  { label: "SSG", value: "SSG" },
  { label: "Premium Security", value: "Premium Security" },
  { label: "BGS", value: "BGS" },
];

const functions = [
  { label: "Director", value: "Director" },
  { label: "Inspector", value: "Inspector" },
  { label: "Agent", value: "Agent" },
  { label: "Employee", value: "Employee" },
];

const handleChange = (value) => {
  console.log(`selected ${value}`);
};

function CompanyProfile() {
  const location = useLocation();

  const [token, setToken] = useState(localStorage.getItem("token"));

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const history = useHistory();
  const { id } = useParams();
  // const [imageURL, setImageURL] = useState(false);
  // const [, setLoading] = useState(false);
  // const [items, setItems] = useState(["SSG", "BGS", "Premium Security"]);
  // const [name, setName] = useState("");
  // const [clients, setClients] = useState([]);
  // const [locations, setLocations] = useState([]);

  const [messageApi, contextHolder] = message.useMessage();

  const [loading, setLoading] = useState(false);
  const [companyName, setCompanyName] = useState();
  const [loadingData, setLoadingData] = useState(false);
  // const [loadingAllLocations, setLoadingAllLocations] = useState(false);
  // const [username, setUsername] = useState();
  // const [password, setPassword] = useState();
  // const [confirmPassword, setConfirmPassword] = useState();
  // const [company, setCompany] = useState();
  // const [clients, setClients] = useState([]);
  // const [locations, setLocations] = useState([]);
  // const [selectedLocations, setSelectedLocations] = useState([]);
  // const [allLocations, setAllLocations] = useState([]);
  // const [email, setEmail] = useState();
  // const [phoneNumber, setPhoneNumber] = useState();
  // const [description, setDescription] = useState();
  // const [role, setRole] = useState(["ROLE_USER"]);
  // const [needsNFC, setNeedsNFC] = useState(true);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const showModal2 = () => {
    setIsModalOpen2(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleOk2 = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleCancel2 = () => {
    setIsModalOpen2(false);
  };

  const success = () => {
    messageApi.open({
      type: "success",
      content: "Company updated successfully",
    });

    history.push("/companies");
  };
  const successDelete = () => {
    messageApi.open({
      type: "success",
      content: "Company deleted successfully",
    });

    history.push("/companies");
  };
  const error = () => {
    messageApi.open({
      type: "error",
      content: "Something went wrong. Please try again later.",
    });
  };

  // const availableLocations = locations.map((location) => {
  //   return {
  //     label: location.locationName,
  //     value: location.id,
  //   };
  // });

  const deleteCompany = async () => {
    const token = localStorage.getItem("token");
    try {
      const response = await axios.delete(
        process.env.REACT_APP_API_URL + `company/deleteCompany?companyId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);
      setIsModalOpen(false);
      successDelete();
      history.push("/companies");
    } catch (error) {
      setIsModalOpen(false);
      console.log(error);
      error();
    }
  };

  // const getLocationsByClient = async (clients) => {
  //   const myArray = [];
  //   for (const client of clients) {
  //     const token = localStorage.getItem("token");
  //     try {
  //       setLoading(true);
  //       const response = await axios.get(
  //         process.env.REACT_APP_API_URL+ `location/getAllLocationsByClient?client=${client}`,
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //       console.log(response);
  //       myArray.push(...response.data);
  //       console.log("myArray: ", myArray);
  //       setLocations(myArray);
  //       setLoading(false);
  //     } catch (error) {
  //       console.log(error);
  //     }
  //   }
  // };

  // const handleChange2 = useCallback(
  //   (item) => {
  //     setClients(item);
  //     setLocations([]);
  //     setSelectedLocations([]);
  //     console.log(item);
  //
  //     getLocationsByClient(item);
  //   },
  //
  //   [locations, clients]
  // );

  // const handleChange3 = (item) => setSelectedLocations(item);

  // const societatiPaza = [
  //   {
  //     label: "AKB SECURITY",
  //     value: "AKB SECURITY",
  //   },
  //   {
  //     label: "ELNET SECURITY",
  //     value: "ELNET SECURITY",
  //   },
  //   {
  //     label: "ORION SECURITY",
  //     value: "ORION SECURITY",
  //   },
  //   {
  //     label: "RPG SECURITY",
  //     value: "RPG SECURITY",
  //   },
  //   {
  //     label: "SSG SECURITY",
  //     value: "SSG SECURITY",
  //   },
  //   {
  //     label: "SSG FIRE&RESCUE",
  //     value: "SSG FIRE&RESCUE",
  //   },
  //   {
  //     label: "HIGHLANDER GUARD",
  //     value: "HIGHLANDER GUARD",
  //   },
  // ];

  // const handleChange4 = (item) => {
  //   setCompany(item);
  //   console.log(item);
  // };

  // const handleChange3 = useCallback(
  //   (item) => {
  //     setSelectedLocations(item);
  //     console.log(item);
  //     // setClients(item);
  //     getLocationsByClient(item);
  //   },
  //
  //   [locations, clients]
  // );

  const [form] = Form.useForm();
  const onFinish = (values) => {
    console.log("Received values of form: ", values);
  };

  const getCompany = async () => {
    const token = localStorage.getItem("token");
    try {
      setLoadingData(true);
      const response = await axios.get(
        process.env.REACT_APP_API_URL + `company/getCompany?companyId=${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response);

      setCompanyName(response.data.companyName);
      // setPassword(response.data.password);
      // setConfirmPassword(response.data.password);
      // setCompany(response.data.company);
      // setClients(response.data.clients);
      // setSelectedLocations(response.data.locationList);
      // setEmail(response.data.email);
      // setPhoneNumber(response.data.phoneNumber);
      // setDescription(response.data.description);
      // setRole(response.data.roles);
      // setNeedsNFC(response.data.needsNFC);

      setLoadingData(false);
    } catch (error) {
      console.log(error);
    }
  };

  const updateCompany = async () => {
    console.log("onFinish called");
    const token = localStorage.getItem("token");
    if (companyName) {
      try {
        const response = await axios.put(
          process.env.REACT_APP_API_URL +
            `company/updateCompany?companyId=${id}`,
          {
            id: id,
            companyName: companyName,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        console.log(response);
        success();
      } catch (e) {
        console.log(e);
        error(e.response.data.reason);
      }
    }
  };

  // const changePassword = async () => {
  //   // console.log("onFinish called");
  //   const token = localStorage.getItem("token");
  //   console.log(role);
  //   console.log(confirmPassword);
  //   if (
  //     // username &&
  //     password &&
  //     confirmPassword
  //     // role &&
  //     // company &&
  //     // clients &&
  //     // selectedLocations
  //   ) {
  //     try {
  //       const response = await axios.put(
  //         process.env.REACT_APP_API_URL+ `user/changeUserPassword`,
  //         {
  //           userId: id,
  //           // email: email,
  //           // username: username,
  //           password: password,
  //           // roles: role,
  //           // company: company,
  //           // clients: clients,
  //           // locationList: selectedLocations,
  //           // phoneNumber: phoneNumber,
  //           // description: description,
  //           // needsNFC: needsNFC,
  //           // avatar: "avatar",
  //           // active: true,
  //         },
  //         {
  //           headers: {
  //             Authorization: `Bearer ${token}`,
  //             Accept: "application/json",
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );
  //
  //       console.log(response);
  //       success();
  //     } catch (e) {
  //       console.log(e);
  //       error(e.response.data.reason);
  //     }
  //   }
  // };

  // const getLocations = async () => {
  //   const token = localStorage.getItem("token");
  //   try {
  //     setLoadingAllLocations(true);
  //     const response = await axios.get(
  //       process.env.REACT_APP_API_URL+ "location/getAllLocations",
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //           Accept: "application/json",
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );
  //     console.log(response);
  //     setAllLocations(response.data);
  //     setLoadingAllLocations(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // const initialClients = clients.map((client) => {
  //   return {
  //     label: client,
  //     value: client,
  //   };
  // });

  // const initialLocations = allLocations.filter((o1) =>
  //   selectedLocations?.some((o2) => o1.id === o2)
  // );

  useEffect(() => {
    let currentDate = new Date();
    setToken(localStorage.getItem("token"));
    console.log("app token", token);
    if (
      (token && jwtDecode(token).exp * 1000 < currentDate.getTime()) ||
      token === null
    ) {
      history.push("/sign-in");
    } else {
      history.push(location.pathname);
    }
  }, [token]);

  useEffect(() => {
    getCompany();
    // getLocations();
  }, []);

  return (
    <>
      {contextHolder}

      <div
        className="profile-nav-bg"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      {loadingData ? (
        <Spinner />
      ) : (
        <>
          <Card
            className="card-profile-head"
            bodyStyle={{ display: "none" }}
            title={
              <Row justify="space-between" align="middle" gutter={[24, 0]}>
                <Col span={24} md={12} className="col-info">
                  <Avatar.Group>
                    {/*<Avatar size={74} shape="square" src={profilavatar} />*/}

                    <div className="avatar-info">
                      <h4 className="font-semibold m-0">{companyName}</h4>
                    </div>
                  </Avatar.Group>
                </Col>
                <Col
                  span={24}
                  md={12}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    height: "100%",
                  }}
                >
                  <h1>{companyName}</h1>
                </Col>
              </Row>
            }
          ></Card>

          <Card
            bordered={false}
            className="header-solid mb-24"
            title={
              <>
                <h6 className="font-semibold">Edit Company</h6>
                <p>Edit company information below</p>
              </>
            }
          >
            <Row
              style={{
                marginLeft: "20px",
                marginRight: "20px",
              }}
            >
              <Form
                {...formItemLayout}
                form={form}
                name="register"
                onFinish={onFinish}
                style={{
                  width: "80%",
                }}
                scrollToFirstError
              >
                <Form.Item
                  name="companyName"
                  label="Company name"
                  initialValue={companyName}
                  tooltip="Please provide a company name"
                  rules={[
                    {
                      required: true,
                      message: "Please input the company name!",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                  />
                </Form.Item>

                {/*<Form.Item*/}
                {/*  name="password"*/}
                {/*  label="Password"*/}
                {/*  initialValue={password}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please input the user password!",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*  hasFeedback*/}
                {/*>*/}
                {/*  <Input.Password*/}
                {/*    value={password}*/}
                {/*    onChange={(e) => setPassword(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="confirm"*/}
                {/*  label="Confirm Password"*/}
                {/*  initialValue={password}*/}
                {/*  dependencies={["password"]}*/}
                {/*  hasFeedback*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please confirm the user password!",*/}
                {/*    },*/}
                {/*    ({ getFieldValue }) => ({*/}
                {/*      validator(_, value) {*/}
                {/*        if (!value || getFieldValue("password") === value) {*/}
                {/*          return Promise.resolve();*/}
                {/*        }*/}
                {/*        return Promise.reject(*/}
                {/*          new Error(*/}
                {/*            "The two passwords that you entered do not match!"*/}
                {/*          )*/}
                {/*        );*/}
                {/*      },*/}
                {/*    }),*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input.Password*/}
                {/*    value={confirmPassword}*/}
                {/*    onChange={(e) => setConfirmPassword(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="company"*/}
                {/*  label="Company"*/}
                {/*  tooltip="Please specify a company"*/}
                {/*  initialValue={company}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: company ? null : true,*/}
                {/*      message: "Please input the company!",*/}
                {/*      // whitespace: true,*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Space*/}
                {/*    style={{*/}
                {/*      width: "100%",*/}
                {/*    }}*/}
                {/*    direction="vertical"*/}
                {/*  >*/}
                {/*    <Select*/}
                {/*      mode="single"*/}
                {/*      style={{*/}
                {/*        width: "100%",*/}
                {/*      }}*/}
                {/*      placeholder="Please select"*/}
                {/*      defaultValue={company}*/}
                {/*      onChange={handleChange4}*/}
                {/*      options={societatiPaza}*/}
                {/*    />*/}
                {/*  </Space>*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="clients"*/}
                {/*  label="Clients"*/}
                {/*  // initialValue={clients.map((client) => {*/}
                {/*  //   return { label: client, value: client };*/}
                {/*  // })}*/}
                {/*  initialValue={initialClients}*/}
                {/*  tooltip="Please specify at least one client"*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: false,*/}
                {/*      message: "Please input the clients!",*/}
                {/*      whitespace: true,*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Space*/}
                {/*    style={{*/}
                {/*      width: "100%",*/}
                {/*    }}*/}
                {/*    direction="vertical"*/}
                {/*  >*/}
                {/*    <Select*/}
                {/*      mode="multiple"*/}
                {/*      style={{*/}
                {/*        width: "100%",*/}
                {/*      }}*/}
                {/*      placeholder="Please select"*/}
                {/*      defaultValue={initialClients}*/}
                {/*      // defaultValue={clients}*/}
                {/*      onChange={handleChange2}*/}
                {/*      options={options}*/}
                {/*    />*/}
                {/*  </Space>*/}
                {/*  /!*<span>*!/*/}
                {/*  /!*  <span style={{ textDecoration: "underline" }}>*!/*/}
                {/*  /!*    Current clients*!/*/}
                {/*  /!*  </span>*!/*/}
                {/*  /!*  :{" "}*!/*/}
                {/*  /!*  {initialClients?.map((client) => {*!/*/}
                {/*  /!*    return <span>{client.label}; </span>;*!/*/}
                {/*  /!*  })}*!/*/}
                {/*  /!*</span>*!/*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="locations"*/}
                {/*  label="Locations"*/}
                {/*  // initialValue={selectedLocations}*/}
                {/*  tooltip="Please specify at least one location"*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: false,*/}
                {/*      message: "Please input the locations!",*/}
                {/*      whitespace: true,*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Space*/}
                {/*    style={{*/}
                {/*      width: "100%",*/}
                {/*    }}*/}
                {/*    direction="vertical"*/}
                {/*  >*/}
                {/*    {loading ? (*/}
                {/*      <Spinner height="auto" size="default" />*/}
                {/*    ) : (*/}
                {/*      <Select*/}
                {/*        mode="multiple"*/}
                {/*        allowClear*/}
                {/*        style={{*/}
                {/*          width: "100%",*/}
                {/*        }}*/}
                {/*        placeholder="Please select"*/}
                {/*        value={initialLocations.map((location) => {*/}
                {/*          return {*/}
                {/*            label: location.locationName,*/}
                {/*            value: location.id,*/}
                {/*          };*/}
                {/*        })}*/}
                {/*        // defaultValue={initialLocations.map((location) => {*/}
                {/*        //   return {*/}
                {/*        //     label: location.locationName,*/}
                {/*        //     value: location.id,*/}
                {/*        //   };*/}
                {/*        // })}*/}
                {/*        onChange={handleChange3}*/}
                {/*        options={availableLocations}*/}
                {/*      />*/}
                {/*    )}*/}
                {/*  </Space>*/}
                {/*  /!*<span>*!/*/}
                {/*  /!*  <span style={{ textDecoration: "underline" }}>*!/*/}
                {/*  /!*    Current Locations*!/*/}
                {/*  /!*  </span>*!/*/}
                {/*  /!*  :{" "}*!/*/}
                {/*  /!*  {initialLocations?.map((location) => {*!/*/}
                {/*  /!*    return <span>{location.locationName}; </span>;*!/*/}
                {/*  /!*  })}*!/*/}
                {/*  /!*</span>*!/*/}
                {/*</Form.Item>*/}

                {/*TODO EMAIL*/}
                {/*<Form.Item*/}
                {/*  name="email"*/}
                {/*  label="E-mail"*/}
                {/*  initialValue={email}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      type: "email",*/}
                {/*      message: "The input is not valid E-mail!",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input*/}
                {/*    value={email}*/}
                {/*    onChange={(e) => setEmail(e.target.value)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  initialValue={phoneNumber}*/}
                {/*  name="phone"*/}
                {/*  label="Phone Number"*/}
                {/*>*/}
                {/*  <Input*/}
                {/*    value={phoneNumber}*/}
                {/*    onChange={(e) => setPhoneNumber(e.target.value)}*/}
                {/*    style={{*/}
                {/*      width: "100%",*/}
                {/*    }}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="intro"*/}
                {/*  label="Description"*/}
                {/*  initialValue={description}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: false,*/}
                {/*      message: "Please input Description",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Input.TextArea*/}
                {/*    value={description}*/}
                {/*    onChange={(e) => setDescription(e.target.value)}*/}
                {/*    showCount*/}
                {/*    maxLength={100}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item*/}
                {/*  name="role"*/}
                {/*  label="Role"*/}
                {/*  initialValue={role}*/}
                {/*  rules={[*/}
                {/*    {*/}
                {/*      required: true,*/}
                {/*      message: "Please select role!",*/}
                {/*    },*/}
                {/*  ]}*/}
                {/*>*/}
                {/*  <Select*/}
                {/*    defaultValue="ROLE_USER"*/}
                {/*    placeholder="Select the role"*/}
                {/*    value={role}*/}
                {/*    options={[*/}
                {/*      { value: "ROLE_USER", label: "User" },*/}
                {/*      { value: "ROLE_ADMIN", label: "Admin" },*/}
                {/*    ]}*/}
                {/*    onChange={(value) => setRole([value])}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                {/*<Form.Item label="Needs NFC" initialValue={needsNFC}>*/}
                {/*  <CustomSwitch*/}
                {/*    checked={needsNFC}*/}
                {/*    onChange={(e) => setNeedsNFC(e)}*/}
                {/*  />*/}
                {/*</Form.Item>*/}

                <Form.Item {...tailFormItemLayout}>
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    type="secondary"
                    className="tag-primary"
                    htmlType="submit"
                    onClick={() => updateCompany()}
                  >
                    Update Company
                  </Button>
                  {/*<Button*/}
                  {/*  style={{ margin: "10px", marginLeft: "0px" }}*/}
                  {/*  onClick={() => showModal2()}*/}
                  {/*  type="info"*/}
                  {/*>*/}
                  {/*  Change User Password*/}
                  {/*</Button>*/}
                  {/*<Modal*/}
                  {/*  title="Warning"*/}
                  {/*  open={isModalOpen2}*/}
                  {/*  okText="Change Password"*/}
                  {/*  okType="danger"*/}
                  {/*  onOk={changePassword}*/}
                  {/*  onCancel={handleCancel2}*/}
                  {/*>*/}
                  {/*  <>*/}
                  {/*    {" "}*/}
                  {/*    <Form.Item*/}
                  {/*      name="password"*/}
                  {/*      label="Insert Password"*/}
                  {/*      initialValue={password}*/}
                  {/*      rules={[*/}
                  {/*        {*/}
                  {/*          required: true,*/}
                  {/*          message: "Please input the user password!",*/}
                  {/*        },*/}
                  {/*      ]}*/}
                  {/*      hasFeedback*/}
                  {/*    >*/}
                  {/*      <Input.Password*/}
                  {/*        value={password}*/}
                  {/*        onChange={(e) => setPassword(e.target.value)}*/}
                  {/*      />*/}
                  {/*    </Form.Item>*/}
                  {/*    <Form.Item*/}
                  {/*      name="confirm"*/}
                  {/*      label="Confirm Password"*/}
                  {/*      initialValue={password}*/}
                  {/*      dependencies={["password"]}*/}
                  {/*      hasFeedback*/}
                  {/*      rules={[*/}
                  {/*        {*/}
                  {/*          required: true,*/}
                  {/*          message: "Please confirm the user password!",*/}
                  {/*        },*/}
                  {/*        ({ getFieldValue }) => ({*/}
                  {/*          validator(_, value) {*/}
                  {/*            if (*/}
                  {/*              !value ||*/}
                  {/*              getFieldValue("password") === value*/}
                  {/*            ) {*/}
                  {/*              return Promise.resolve();*/}
                  {/*            }*/}
                  {/*            return Promise.reject(*/}
                  {/*              new Error(*/}
                  {/*                "The two passwords that you entered do not match!"*/}
                  {/*              )*/}
                  {/*            );*/}
                  {/*          },*/}
                  {/*        }),*/}
                  {/*      ]}*/}
                  {/*    >*/}
                  {/*      <Input.Password*/}
                  {/*        value={confirmPassword}*/}
                  {/*        onChange={(e) => setConfirmPassword(e.target.value)}*/}
                  {/*      />*/}
                  {/*    </Form.Item>*/}
                  {/*  </>*/}
                  {/*</Modal>*/}
                  <Button
                    style={{ margin: "10px", marginLeft: "0px" }}
                    onClick={() => showModal()}
                    type="danger"
                  >
                    DELETE Company
                  </Button>
                  <Modal
                    title="Warning"
                    open={isModalOpen}
                    okText="Delete"
                    okType="danger"
                    onOk={deleteCompany}
                    onCancel={handleCancel}
                  >
                    <p>Are you sure you want do delete this company?</p>
                  </Modal>
                </Form.Item>
              </Form>
            </Row>
          </Card>
        </>
      )}
    </>
  );
}

export default CompanyProfile;
